import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
class ConfigurationItemTabUniversalFieldTab {
    ConfigurationItem: any;
    ConfigurationItemTabPageId: string;
    Loading = ko.observable<boolean>(false);
    UniversalFields = ko.observableArray<any>([]);
    UniversalFieldValues = ko.observableArray<any>([]);
    TemplateName = ko.observable<string>("");
    TemplateContext = ko.observable<any>(null);
    IsHistory = ko.observable<boolean>(false);
    constructor(public TabPage: TabPage, parent: any) {
        this.ConfigurationItem = parent;
        this.ConfigurationItemTabPageId = TabPage.Url().substr(TabPage.Url().lastIndexOf("/") + 1);
        this.TabPage.DirtyFlag.subscribe((isDirty) => {
            //TODO: Parent Methode zum Dirty Check der Childtabs aufrufen (für * im Haupttab)
            if (isDirty) {
                this.ConfigurationItem.TabPage.DirtyFlag(true);
            }
        });
    }
    Refresh() {
        return this.UpdateValues()
            .then(() => {
            this.TabPage.DirtyFlag.reset();
        });
    }
    Save(version) {
        this.Loading(true);
        this.TabPage.IsLoading(true);
        this.CompleteCheck();
        return Bao.post("ConfigurationItemTabUniversalFieldTab/Save", JSON.stringify({
            models: ko.map.toJS(this.UniversalFieldValues),
            version: version
        }), (result) => {
            this.Loading(false);
            this.TabPage.IsLoading(false);
            this.TabPage.DirtyFlag(false);
        });
    }
    init() {
        return this.UpdateTab();
    }
    UpdateTab() {
        var def = $.Deferred();
        this.TemplateName(null);
        this.TemplateContext(null);
        Bao.post("ConfigurationItemTabUniversalFieldTab/GetUniversalFields", JSON.stringify({
            configurationItemTabId: this.ConfigurationItemTabPageId
        }), (result) => {
            var htmlUrl = "ConfigurationItemTabUniversalFieldTabTemplate" + this.ConfigurationItemTabPageId;
            this.UniversalFields(result.Models);
            this.UpdateValues().then(() => {
                Bao.Templates[htmlUrl] = result.html;
                this.TemplateName(htmlUrl);
                def.resolve();
            });
        });
        return def.promise();
    }
    ;
    UpdateValues() {
        return Bao.post("ConfigurationItemTabUniversalFieldTab/GetUniversalFieldValues", JSON.stringify({
            configurationItemId: this.ConfigurationItem.ConfigurationItemId(),
            configurationItemTabId: this.ConfigurationItemTabPageId
        }), (result) => {
            ko.map.fromJS(result, this, this.TabPage.DirtyFlag);
            this.TemplateContext(this);
        });
    }
    getTagObservable(universalFieldId) {
        var obs = null;
        ko.utils.arrayForEach(this.UniversalFieldValues(), (item) => {
            if (ko.unwrap(item.UniversalFieldId) == universalFieldId) {
                obs = item;
            }
        });
        return obs;
    }
    ;
    getTagModel(universalFieldId) {
        var obs = null;
        ko.utils.arrayForEach(this.UniversalFields(), (item) => {
            if (ko.unwrap(item.UniversalFieldId) == universalFieldId) {
                obs = item;
            }
        });
        return obs;
    }
    ;
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    CompleteCheck() {
        let universalFields = this.UniversalFields();
        if (universalFields === null || typeof universalFields === "undefined") {
            return true;
        }
        var result = true;
        for (var item of universalFields.filter(x => x.IsMandatory)) {
            let values = this.UniversalFieldValues().filter(x => x.UniversalFieldId() === item.UniversalFieldId);
            if (!ko.unwrap(values)) {
                result = false;
            }
            let value = ko.unwrap(values[0]);
            if (!value) {
                result = false;
            }
            switch (value.UniversalFieldTypeId().toLowerCase()) {
                case "b3f7d21b-56dc-4258-91ba-00f0d64cb2b2": //Optionsfelder
                    if (this.StringIsNullOrEmpty(value.TextValue()))
                        result = false;
                    break;
                case "c694105e-3356-4fd9-a702-682e2e18520c": //Alphanumerisch
                    if (this.StringIsNullOrEmpty(value.TextValue()))
                        result = false;
                    break;
                case "1eb0ef5b-07bd-476c-8415-d32931cd6bca": //Numerisch
                    if (this.StringIsNullOrEmpty(value.NumericValue()))
                        result = false;
                    break;
                case "6c4865b4-3e87-4f64-be09-9e461e88550a": //Ja/Nein
                    if (this.StringIsNullOrEmpty(value.BooleanValue()))
                        result = false;
                    break;
                case "0fc89eed-9510-4094-a0a8-835cee0a3f24": //Auswahl mit Suchdialog
                    if (this.StringIsNullOrEmpty(value.TextValue()))
                        result = false;
                    break;
                case "02dd5bf9-f182-4368-917e-dd053ee2f4a7": //Auswahl Drop-Down
                    if (this.StringIsNullOrEmpty(value.TextValue())) {
                        result = false;
                    }
                    break;
                case "e2a64241-6766-4159-81d7-257da36327bb": // DateTimePicker
                    if (this.StringIsNullOrEmpty(value.DateTimeValueJs()))
                        result = false;
                    break;
                case "8de0ffb8-1250-4322-85ee-2a64c46bbb78": // Searchdialog with searchobject
                    if (this.StringIsNullOrEmpty(value.TextValue()))
                        result = false;
                    break;
                case "b453e0de-0f88-4f22-bfff-a0189f6a117b": // Text area
                    if (this.StringIsNullOrEmpty(value.TextValue()))
                        result = false;
                    break;
                case "523c8fc3-b4f5-4ac9-8af7-ad883b7f8255": // checkbox
                    if (this.StringIsNullOrEmpty(value.BooleanValue()))
                        result = false;
                    break;
            }
            if (!result) {
                break;
            }
        }
        return result;
    }
    StringIsNullOrEmpty(string) {
        // solange die funktion noch nicht voll funktionstüchtig ist(#108283)
        //return Bao.Utils.String.IsNullOrEmpty(string);
        // nutze eigene Implementierung
        if (string === null)
            return true;
        else if (string === "")
            return true;
        else if (typeof string === "undefined")
            return true;
        return false;
    }
    ;
    pauseDirtyFlag() {
        this.TabPage.DirtyFlag.pause();
    }
    resumeDirtyFlag() {
        this.TabPage.DirtyFlag.resume();
    }
}
export default ConfigurationItemTabUniversalFieldTab;